import debug from 'Helper/debugHelpers'
import globalConfig from 'Helper/configHelpers'
import { put, call } from 'redux-saga/effects'
import { delay } from 'Helper/customReduxEffects.js'
import { get } from 'Helper/xtract_api'
import checkResult from './checkResult'
import connectionFailure from './connectionFailure'
import dataManager from './dataManagerSagas'

const configSectionFix1of2 = (result) => {
  // there used to be two ways of refering to dashboard, the code is being converted to only use
  // nurseDashboard but databases haven't been migrated yet so the data may be returned as 'dashboard'.
  // once migrations correct databases this fix function (and 2of2) can be removed.
  const configFixer = (config) => {
    if (config.section === 'dashboard') {
      config.section = 'nurseDashboard'
    }
    return config
  }
  if (result?.data?.data?.config) {
    if (Array.isArray(result.data.data.config)) {
      result.data.data.config.forEach((config, idx) => {
        result.data.data.config[idx] = configFixer(config)
      })
    } else {
      result.data.data.config = configFixer(result.data.data.config)
    }
  } else if (result?.data?.data?.globalAppConfigAuth?.config_search) {
    result.data.data.globalAppConfigAuth.config_search.forEach((config, idx) => {
      result.data.data.globalAppConfigAuth.config_search[idx] = configFixer(config)
    })
  }

  return result
}

export default function * CRUDcall(setup) {
  const { API_FAIL_COUNT, token, id, obj, transaction, action, idsObj } = setup
  const { api_base_url: API_BASE_URL } = globalConfig
  let { method, resource, resourceName } = setup
  let result

  try {
    debug.logObject(
      'making ' +
        method +
        ' API call to ' +
        API_BASE_URL +
        '/' +
        resource +
        ' with id = ' +
        id,
      obj,
      debug.logLevels.API
    )

    result = yield call(
      get,
      token,
      resource,
      method.replace('_PARTIAL', ''),
      id,
      obj,
      transaction,
      action.config
    )
  } catch (error) {
    if (error.name === 'AbortError' || error === 'Canceled due to submission of updated api call') {
      // we canceled this api call so we don't ned to do anything else
      const message = typeof error === 'string' ? error.toLowerCase() : 'was aborted.'
      debug.log(`Call for resource ${resource} ${message}`, debug.logLevels.API)
      return
    }
    // some error
    debug.log('error: ' + error, debug.logLevels.API, 'error')
    // this really only runs for errors thrown by fetch I believe which means
    // rarely occuring network errors (I think). potential future cleanup
    // improvements now that I understand this. All status codes would
    // be handled below when we call checkResult and run the error handlers.
    if (yield call(connectionFailure, API_FAIL_COUNT, error)) {
      // schedule a retry of the same API call in 1 second
      yield delay(1000)

      yield put({
        type: 'SET_API_FAIL_COUNT',
        value: parseInt(API_FAIL_COUNT) + 1
      })

      yield put({ ...action })
      debug.log(
        'doing retry of the same call. API_FAIL_COUNT at ' +
          (parseInt(API_FAIL_COUNT) + 1),
        debug.logLevels.API,
        'info'
      )
    }

    return null
  }

  result = configSectionFix1of2(result)

  result = yield call(checkResult, result, action)

  if (result == null) {
    // there was an error. It was handled in checkResult so just return
    return
  } else {
    // results checked out so reset failcount to 0
    yield put({
      type: 'SET_API_FAIL_COUNT',
      value: 0
    })
  }

  const parts = resource.split('?')
  if(parts.length > 1) {
    const params = parts[1].split('&')
    if(params.find(param => param.indexOf('LIMIT') != -1) != null) {
      method = method + '_partial'
    }
    resource = resource.split('?')[0]
  }

  const resourceArray = resource.split('/')
  resource = resourceArray.pop()

  // this list of conditions matches those in the api parsePath trait.
  const excludes = [
    '_search',
    'limit',
    'offset',
    'mix',
    'assignment',
    'answered',
    'link',
    'validate',
    'make_dilution',
    'start_mix',
    'all',
    'pending',
    'import',
    'reject',
    'transition',
    'metadata'
  ]
  while (
    (excludes.find(tail => tail === resource.toLowerCase()) != null ||
      !isNaN(resource)) &&
    resourceArray.length > 0
  ) {
    resource = resourceArray.pop()
  }
  if (
    method.toUpperCase() !== 'READ' &&
    method.toUpperCase() !== 'READ_ALL' &&
    method.toUpperCase() !== 'SEARCH' &&
    method.toUpperCase() !== 'SEARCH_PARTIAL' &&
    resource.toUpperCase() !== 'LOCK'
  ) {
    // if the call is a create/update/delete then we pass the details to the data manager to determine if there is any
    // data currently in redux that may need to be refreshed based on the changes that this call resulted in. Read
    // calls wont have changed anything so they can bypass this step.
    try {
      yield * dataManager({
        resource: resourceName + '_POST_API',
        method: method.toUpperCase(),
        ids: idsObj,
        result: result.data[resource],
        server_time: result.server_time
      })
    } catch (error) {
      debug.log('data manager error: ' + error, debug.logLevels.API, 'error')
    }
  }

  yield put({
    type: 'STORE_' + resourceName + '_' + method.toUpperCase(),
    ids: idsObj,
    result: result.data[resource],
    server_time: result.server_time
  })

  return result.data[resource]
}
